import React from 'react';
import { ListProps } from 'react-admin';
import { IntegrationListPage } from '../Common/Integrations';
import healthcheckConfig from './config';

const HealthcheckList = (props: ListProps) => (
    <IntegrationListPage config={healthcheckConfig} listProps={props} />
);

export default HealthcheckList;
